module.exports = __webpack_public_path__ + "img/banner.4b8e74fb.png";